export const defaultEntity = 'demo';
export const entities = ['demo'];
export const labels = {
    demo: 'Demo list',
};